import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';

const styles = css`
  .HomeCard_wrapper {
    background: ${colors.white};
    transition: all .3s ease;
    background-size: cover;
    background-position: center;
    min-height: 160px;
    width: 300px;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${colors.brand1};
      opacity: .65;
    }
  }
  .HomeCard_content {
    position: absolute;
    bottom:0;
    width:100%;
    z-index:1;
  }
  .HomeCard_address {
    padding:10px;
    font:700 22px/1 ${typography.Serif};
    color: ${colors.white};
    margin:0;
  }
  .HomeCard_city {
    font:700 15px/1 ${typography.Condensed};
    text-transform: uppercase;
    color: ${colors.white};
  }
  .HomeCard_infoWrapper {
    padding:10px;
    position:relative;
    display:flex;
    flex-flow:row nowrap;
    justify-content:space-between;
    &::after {
      content: '';
      display: block;
      background-color: ${colors.brand1Dark};
      opacity: .65;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
    }
  }
  .HomeCard_infoWrapper-button {
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
  }
  .HomeCard_detailButton {
    height: 20px;
    width: 20px;
    background-image: url('/images/icon-arrow-right-white.svg');
    background-position: center center;
    background-repeat: no-repeat;
  }
  .HomeCard_list {
    list-style-type:none;
    padding:0 0 5px 0;
    margin: 0;
    color: ${colors.white};
    font:700 15px/1 ${typography.Condensed};
    position: relative;
  }
  .HomeCard_listItem {
    margin: 0;
    position: relative;
    z-index: 2;
  }
  .HomeCard_list-icon {
    list-style-type:none;
    padding:0;
    display: flex;
    list-style: none;
    margin: 0;
    color: ${colors.white};
    position: relative;
  }
  .HomeCard_list-iconItem {
    text-align: center;
    font:400 15px/1 ${typography.Condensed};
    margin: 0 12px 0 0;
    position: relative;
    z-index: 2;
  }
  .HomeCard_list-icon {
    list-style: none;
  }
  .HomeCard_list-iconItem {
    text-align: center;
    font-size:300 15px/1 ${typography.Condensed};
  }
  .HomeCard_list-iconIcon {
    margin: 0 0 4px 0;
    display: none;
  }
  .HomeCard_list-iconValue {
    font-weight: 700;
    margin: 0 3px 0 0;
  }
`;

function HomeCardMapPopUp({ home }) {
  return (
    <div className={styles}>
      <Link name="home-detail" home={home}>
        <div className="HomeCard_wrapper" style={{ backgroundImage: `url(${buildThumbnailUrl(get(home, 'photos[0].contentUrl'), { width: 600, height: 600 })})` }}>
          <div className="HomeCard_content">
            <h4 className="HomeCard_address">
              {get(home, 'address.streetAddress')}<br />
              <span className="HomeCard_city">{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}</span>
            </h4>
            <div className="HomeCard_infoWrapper">
              <div className="HomeCard_infoWrapper-info">
                {
                  get(home, 'price') &&
                  <ul className="HomeCard_list">
                    {
                      get(home, 'price') &&
                      <li className="HomeCard_listItem">
                        {numeral(get(home, 'price')).format('$0,0')}
                      </li>
                    }
                  </ul>
                }
                <ul className="HomeCard_list-icon">
                  {
                    get(home, 'beds') &&
                    <li className="HomeCard_list-iconItem">
                      <span className="HomeCard_list-iconIcon"><img src="images/icon-beds.svg" alt="" /></span>
                      <span className="HomeCard_list-iconValue">{get(home, 'beds')}</span>
                      <span className="HomeCard_list-iconLabel">Beds</span>
                    </li>
                  }
                  {
                    get(home, 'bathsFull') &&
                    <li className="HomeCard_list-iconItem">
                      <span className="HomeCard_list-iconIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                      <span className="HomeCard_list-iconValue">
                        {get(home, 'bathsFull')} {get(home, 'bathsHalf', 0) > 0 && '.5'}
                      </span>
                      <span className="HomeCard_list-iconLabel">Baths</span>
                    </li>
                  }
                  {
                    get(home, 'sqft') &&
                    <li className="HomeCard_list-iconItem">
                      <span className="HomeCard_list-iconIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                      <span className="HomeCard_list-iconValue">{numeral(get(home, 'sqft')).format('0,0')}</span>
                      <span className="HomeCard_list-iconLabel">SQ FT</span>
                    </li>
                  }
                </ul>
              </div>
              <div className="HomeCard_infoWrapper-button">
                <div className="HomeCard_detailButton" />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

HomeCardMapPopUp.propTypes = {
  home: PropTypes.object,
};

HomeCardMapPopUp.defaultProps = {
  home: undefined,
};

export default withData(
  {
    home: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeCardMapPopUp);



// WEBPACK FOOTER //
// ./src/components/HomeCardMapPopUp.js